import HomePage from './pages/Home'
import MintNft from './pages/MintNft'
import IssueToken from './pages/IssueToken'
import Register from './pages/Register'
import Login from './pages/Login'
import EmailConfirmation from './pages/EmailConfirmtion'
import VerifyAccount from './pages/VerifyAccount'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'
import Welcome from './pages/Welcome'
import IssueNftCollection from './pages/IssueNftCollection'
import ControlChanges from './pages/ControlChanges'
import NftSetRole from './pages/NftSetRole'
import APIKeys from './pages/APIKeys'
import APIKeyGenerate from './pages/APIKeyGenerate'
import Projects from './pages/Projects'
import Project from './pages/Project'
import AirDrop from './pages/AirDrop'
import IssueContract from './pages/IssueContract'
import AirDrops from './pages/AirDrops'
import Notifications from './pages/Notifications'

export const routeNames = {
  welcome: '/',
  home: '/dashboard',
  issueToken: '/issue-token',
  setRole: '/set-role',
  unsetRole: '/unset-role',
  mintNft: '/mint-nft',
  issueNftCollection: '/issue-nft-collection',
  register: '/register',
  login: '/login',
  emailConfirmation: '/email-confirmation',
  verifyAccount: '/verifyAccount',
  forgotPassword: '/forgot-password',
  resetPassword: '/resetPassword',
  controlChanges: '/control-changes',
  nftSetRole: '/nft-set-role',
  apiKeys: '/api-keys',
  apiKeyGenerate: '/api-generate',
  project: '/projects/:projectId',
  projects: '/projects',
  airDropCreate: '/airdrop/create',
  airDropView: '/airdrop/:id',
  airdrops: '/airdrops',
  notifications: '/notifications',
  issueVestingContract: '/issue-vesting-contract',
  issueStakingContract: '/issue-staking-contract',
}

const routes = [
  {
    path: routeNames.welcome,
    component: Welcome,
    authenticatedRoute: true,
  },
  {
    path: routeNames.home,
    component: HomePage,
    title: 'Hello #name#, what do you want to create today?',
    authenticatedRoute: false,
  },
  {
    path: routeNames.issueToken,
    component: IssueToken,
    title: 'Issue token',
    authenticatedRoute: false,
  },
  {
    path: routeNames.mintNft,
    component: MintNft,
    authenticatedRoute: false,
  },
  {
    path: routeNames.issueNftCollection,
    component: IssueNftCollection,
    title: 'Issue NFT collection',
    authenticatedRoute: false,
  },
  {
    path: routeNames.register,
    component: Register,
    authenticatedRoute: true,
  },
  {
    path: routeNames.login,
    component: Login,
    authenticatedRoute: true,
  },
  {
    path: routeNames.emailConfirmation,
    component: EmailConfirmation,
    authenticatedRoute: true,
  },
  {
    path: routeNames.verifyAccount,
    component: VerifyAccount,
    authenticatedRoute: true,
  },
  {
    path: routeNames.forgotPassword,
    component: ForgotPassword,
    authenticatedRoute: true,
  },
  {
    path: routeNames.resetPassword,
    component: ResetPassword,
    authenticatedRoute: true,
  },
  {
    path: routeNames.controlChanges,
    component: ControlChanges,
    authenticatedRoute: false,
  },
  {
    path: routeNames.nftSetRole,
    component: NftSetRole,
    authenticatedRoute: false,
  },
  {
    path: routeNames.apiKeys,
    component: APIKeys,
    authenticatedRoute: false,
  },
  {
    path: routeNames.apiKeyGenerate,
    component: APIKeyGenerate,
    authenticatedRoute: false,
  },
  {
    path: routeNames.project,
    component: Project,
    authenticatedRoute: false,
  },
  {
    path: routeNames.projects,
    component: Projects,
    title: 'My Projects',
    authenticatedRoute: false,
  },
  {
    path: routeNames.airDropCreate,
    component: AirDrop,
    authenticatedRoute: false,
  },
  {
    path: routeNames.airDropView,
    component: AirDrop,
    authenticatedRoute: false,
  },
  {
    path: routeNames.airdrops,
    component: AirDrops,
    authenticatedRoute: false,
  },
  {
    path: routeNames.notifications,
    component: Notifications,
    authenticatedRoute: false,
  },
  {
    path: routeNames.issueStakingContract,
    component: IssueContract,
    title: 'Issue staking contract',
    authenticatedRoute: false,
  },
  {
    path: routeNames.issueVestingContract,
    component: IssueContract,
    title: 'Issue vesting contract',
    authenticatedRoute: false,
  },
]
export default routes
